/// <reference path="appbase.ts" />


namespace TerminalApp {


    class StockingLotElement {
        index: number = 0;
        renderedIndex: number = 0;
        arrival: SP.ArrivalInfo;
        data: SP.StockingLotInfo;
        html: HTMLElement;
        text_name: HTMLElement;
        text_date: HTMLElement;
        text_location: HTMLElement;
        text_description: HTMLElement;
        text_arrival_info: HTMLElement;
        text_icon: HTMLImageElement;
        POLine: SP.PurchaseOrderLineInfo;
        constructor(data: SP.StockingLotInfo, arrival: SP.ArrivalInfo, POLine: SP.PurchaseOrderLineInfo) {
            this.arrival = arrival;
            this.data = data;
            this.POLine = POLine;
            this.html = CreateButton(data.item.imageUrl, null);
            this.html.classList.add("full");
            this.html.style.height = "88px";


            if (!arrival.arrivalFinished) {

                var m = new SP.SwipeMenu(
                    /*Element*/
                    this.html,

                    /*Click Event*/
                    null,

                    /*buttons*/
                    [
                    /*Edit Button  */{
                            icon: "<i class='fas fa-edit'></i>", text: SP.Localize("word_edit"), color: "#359ee8", confirm: false, action: async () => {
                                if (await SP.confirmX("Confirm Edit")) {
                                    (GetApp("app_arrival_show") as App_Arrival_Show).editStockingLot(this.data.id);
                                }
                                m.return();
                            }
                        }
                    ],
                    "app_arrival_show"
                );
            }

            this.updateText();


        }



        updatePOInfo(finished:boolean) {
            if (!this.POLine) return;
            var recieved = this.POLine.beeingDeliveredQty;
            var incomming = this.POLine.undeliveredQty;
            var total = this.POLine.itemTotalIncommingAllOrders;


            var color = recieved == incomming ? "#56b71e" : recieved > incomming ? "#ffadad" : "#b7b7b7";
            this.text_arrival_info.innerHTML = "<span class='delivery-label' style='background-color:" + color + "'><b>" + this.POLine.loc + ":</b> " + (recieved ?? "0") + " / " + (incomming ?? "0") + " / " + (total ?? "0") + " </span>";
        }

        updateText() {
            //clear
            this.html.innerHTML = "";

            //icon
            this.text_icon = document.createElement("img");
            this.text_icon.classList.add("icon");
            this.text_icon.src = this.data.item.imageUrl;
            this.text_icon.style.pointerEvents = "auto";
            this.text_icon.addEventListener("click", (e) => {
                itemShortcutAssistant.open_with_info(this.data.item);
                e.preventDefault();
                e.stopPropagation();
            });

            this.html.appendChild(this.text_icon);

            //date/user text
            this.text_date = document.createElement("div");
            this.text_date.classList.add("text", "bottom", "right", "small");
            this.text_date.innerHTML = `${this.data.createUser} <span class='bold'>${this.data.timestamp}</span>`;
            this.html.appendChild(this.text_date);

            //date/user name
            this.text_name = document.createElement("div");
            this.text_name.classList.add("text", "top", "big", "left");
            this.text_name.style.right = "130px";
            this.text_name.innerHTML = `<span class="label">x ${this.data.initialQuantity}${(this.data.availableQuantity != this.data.initialQuantity ? " (" + this.data.availableQuantity + ")" : "")}</span> ${this.data.item.sku}`;
            this.html.appendChild(this.text_name);

            //date/user name
            this.text_description = document.createElement("div");
            this.text_description.classList.add("text", "left", "small");
            this.text_description.style.lineHeight = "16px";
            this.text_description.innerHTML = `<span class="bold">${this.data.item.barcodes.join(", ")}</span><br>${this.data.item.description}`;
            this.html.appendChild(this.text_description);

            //date/user name
            this.text_arrival_info = document.createElement("div");
            this.text_arrival_info.classList.add("arrival_info");
            this.text_arrival_info.style.lineHeight = "16px";
            this.text_arrival_info.innerHTML = ``;
            this.html.appendChild(this.text_arrival_info);

            //date/user name
            var si = new PlacementInfoBox(this.data.stockPlacementData, false, this.data.item);
            this.text_location = document.createElement("div");
            this.text_location.classList.add("text", "top", "right");
            this.text_location.style.pointerEvents = "auto";
            this.text_location.innerHTML = `<span class="label">${si.string_location}</span>`;
            this.text_location.querySelector(".label").addEventListener("click", (e) => {
                placementShortcutAssistant.open_with_data(this.data.stockPlacementData, this.data.item);
                e.preventDefault();
                e.stopPropagation();
            });
            this.html.appendChild(this.text_location);

        }
    }

    class ArrivalItem {
     
        input_quantity: HTMLInputElement;
        input_production: HTMLInputElement;
        input_expiration: HTMLInputElement;
        input_batch: HTMLInputElement;
        item: SP.ItemInfo;
        editLot: SP.StockingLotInfo;
        poInfo: SP.PurchaseOrderLineInfo;
        newId: string;
        get quantity() {
            return parseFloat(this.input_quantity.value);
        }
        addQuantity(qty: number) {
            var current_qty = parseFloat(this.input_quantity.value);
            this.input_quantity.value = Math.max(0, (isNaN(current_qty) ? qty : (current_qty + qty))).toString();
        }

        arrivalId: string = null;
        barcodeScan: string = null;

        container = document.createElement("div");
        constructor(arrivalId: string, item: SP.ItemInfo, editLot: SP.StockingLotInfo = null, barcodeScan: string = null, poInfo: SP.PurchaseOrderLineInfo = null, isPurchaseOrder: boolean = false) {
            this.arrivalId = arrivalId;
            this.item = item;
            this.editLot = editLot;
            this.barcodeScan = barcodeScan;
            this.newId = SP.Guid.newGuid();
            this.poInfo = poInfo;
            this.container.classList.add("arrival_item");
            var name = (item.manufacturerName + item.modelNo).length ? (item.manufacturerName + " " + item.modelNo).trim() : "";


            var barcodes = [];
            for (var key in item.allBarcodes) {
                var bc = key;
                if (item.allBarcodes[bc] > 1) {
                    bc += " <span class='label'>COL " + item.allBarcodes[bc] + "</span>";
                }
                barcodes.push(bc);
            }
            console.log("ITEM:", item);
            this.container.innerHTML = `
            <div class="item_info_dialog">
                <div class="close">X</div>
                <div style="${item.abc_orders && item.abc_orders != "D" ? "" : "display:none"}" class="classification label label-${item.abc_orders == "A" ? "success" : item.abc_orders == "B" ? "warning" : "danger"}">${item.abc_orders}</div>
                <div class="image">${item.imageUrl ? "<img src='" + item.imageUrl + "' / >" : ""}</div>
                <div class="info">
                    <div class="sku">${item.sku + (name.length ? " (" + name + ")" : "")}</div>
                    <div class="barcodes">${barcodes.join('<br />')}</div>
                    <div class="description">${item.description}</div>
                    <div class="locations"></div>
                    <div style="display:none" class="po_info"></div>
                </div>
                <div style="display:none" class="input-group production-group">
                    <div class="input-group-addon">
                        <i class="fas fa-calendar"></i>
                    </div>
                    <input type="text" class="form-control pull-right production-date" onfocus="this.type='date';" autocomplete="off" placeholder="${SP.Localize("sentance_production_date")}">
                </div>
                <div style="display:none" class="input-group expiration-group">
                    <div class="input-group-addon">
                        <i class="fas fa-calendar"></i>
                    </div>
                    <input type="text" class="form-control pull-right expiration-date" onfocus="this.type='date';" autocomplete="off" placeholder="${SP.Localize("sentance_expiration_date")}">
                </div>
                <div style="display:none" class="input-group batch-group">
                    <div class="input-group-addon">
                        <i class="fas fa-hashtag"></i>
                    </div>
                    <input type="text" class="form-control pull-right batch-number" autocomplete="off" placeholder="batch-, lotnumber">
                </div>
                    <div class="input-amount quantity-group">
                    <div class="button minus">
                        <i class="fas fa-minus"></i>
                    </div>
                    <input type="number" class="form-control arrival_item_quantity">
                    <div class="button plus">
                        <i class="fas fa-plus"></i>
                    </div>
                </div>
            
       
            </div>
            <div class="error" style="display: none;"></div>
            `;
            //<div id="arrival_add_item_success" class="error" style = "background-color: rgb(134, 165, 111); display: block;" bis_skin_checked = "1" > Succes < /div>


            if (isPurchaseOrder) {
                var po_container = this.container.querySelector(".po_info") as HTMLElement;
                po_container.style.display = "block";

                if (poInfo) {
                    var expected = poInfo.undeliveredQty - poInfo.beeingDeliveredQty;
                    if (editLot) expected += editLot.initialQuantity;
                    po_container.innerHTML = "<b>" + SP.Localize("sentance_expected_quantity") + ": " + expected + " (loc: " + poInfo.loc + ")</b>";
                }
                else {
                    po_container.innerHTML = "<b>" + SP.Localize("sentance_expected_quantity") + ": " + SP.Localize("sentance_not_found") + "</b>";
                }
            }

            this.container.querySelector(".image").addEventListener("click", () => {
                itemShortcutAssistant.open_with_id(item.id);
            });

            App_Arrival_Show.instance.arrival_item_container.appendChild(this.container);


            var close_button = this.container.querySelector(".close");
            close_button.addEventListener("click", () => {
                delete App_Arrival_Show.instance.scannedItems[this.item.id];
                this.container.remove();
                App_Arrival_Show.instance.updateFinishButtonState();
            });

            this.input_production = this.container.querySelector(".production-date");
            this.input_expiration = this.container.querySelector(".expiration-date");
            this.input_batch = this.container.querySelector(".batch-number");
            this.input_quantity = this.container.querySelector(".arrival_item_quantity");
            this.input_quantity.addEventListener("keydown", e => {
                if (e.which == 13)
                    this.input_quantity.blur();
            });

            this.input_quantity.addEventListener("focus", e => {
                this.input_quantity.select();
            });

            var minus_button = this.container.querySelector(".button.minus");
            minus_button.addEventListener("click", () => {
                this.addQuantity(-1);
            });

            var plus_button = this.container.querySelector(".button.plus");
            plus_button.addEventListener("click", () => {
                this.addQuantity(1);
            });

            if (item.expirable) (this.container.querySelector(".expiration-group") as HTMLElement).style.display = "block";
            if (item.useProductionDate) (this.container.querySelector(".production-group") as HTMLElement).style.display = "block";
            if (item.useBatchNumber) (this.container.querySelector(".batch-group") as HTMLElement).style.display = "block";

            this.addLocations();

            if (editLot) {
                console.log(editLot);
                this.input_expiration.value = editLot.expirationDate;
                this.input_production.value = editLot.productionDate;
                this.input_batch.value = editLot.batchNumber;
                this.input_quantity.value = editLot.initialQuantity.toString();
            }
        }

        posting = false;
        posted = false;

        loadGS1Data(gs1Data: SP.GS1Data) {
            if (gs1Data?.batchOrLotNumber) {
                this.input_batch.value = gs1Data?.batchOrLotNumber;
            }

            if (gs1Data?.productionDate) {
                this.input_production.value = gs1Data.productionDate;
            }

            if (gs1Data?.bestBeforeDate) {
                this.input_expiration.value = gs1Data.bestBeforeDate;
            }

        }

        async post(placementId: number) {
            if (this.posting || this.posted) return false;
            this.posting = true;
            try {
                var result = await SP.post<any>("/api/v1/stockinglot/import", {
                    id: this.editLot?.id ?? this.newId,
                    arrivalId: this.arrivalId,
                    itemId: this.item.id,
                    stockPlacementId: placementId,
                    initialQuantity: this.quantity,
                    expirationDate: this.input_expiration.value ? this.input_expiration.value : null,
                    productionDate: this.input_production.value ? this.input_production.value : null,
                    batchNumber: this.input_batch.value,
                    purchaseOrderLineId: this.poInfo?.id
                })

                var message = this.container.querySelector(".error") as HTMLElement;
                message.style.backgroundColor = "#86a56f";
                message.innerHTML = "Success";
                message.style.display = "block";

                //Error
                if (result.status != 200) {
                    message.style.backgroundColor = "";
                    message.innerHTML = `${result.status}: ${result.msg}`;
                    SP.Sounds.Error.play();
                    return false;
                }

                //success
                SP.Sounds.Success.play();
                this.posted = true;
                this.container.querySelector(".item_info_dialog").remove();
                delete App_Arrival_Show.instance.scannedItems[this.item.id];
                setTimeout(() => {
                    this.container.remove();
                }, 2000);
                return true;
            }
            finally {
                this.posting = false;
            }
        }

        async addLocations() {
            var lots = await SP.Data.StockingLot.getItemStockingLotInfos(this.item.id, false);

            //clear location info
            let loc_container = this.container.querySelector(".locations");
            var preferred = this.item.preferredStockPlacementData;

            //extract location inofo
            let locations = {} as any;

            if (preferred) {
                locations[preferred] = 0;
            }

            lots.forEach(l => {
                if (l.placementQuantity > 0) {
                    if (!locations[l.stockPlacementData]) locations[l.stockPlacementData] = l.placementQuantity;
                    else locations[l.stockPlacementData] += l.placementQuantity;
                }
            });



            for (var location in locations) {
                let t = new PlacementInfoBox(location, false, this.item);


                let amt = locations[location];

                let item = document.createElement("div");
                let location_span = document.createElement("span");
                let count_span = document.createElement("span");
                count_span.classList.add("label");
                location_span.innerHTML += t.string_location;

                if (preferred == location)
                    location_span.innerHTML += ' <i class="fa-solid fa-star"></i>';
                count_span.innerHTML = amt;




                item.appendChild(location_span);
                item.appendChild(count_span);

                loc_container.appendChild(item);
            }
        }
    }

    export class App_Arrival_Show extends AppBase {
        static instance: App_Arrival_Show;
        arrivalInfo: SP.ArrivalInfo;
        arrivals: { [id: string]: StockingLotElement } = {};
        items: SP.StockingLotInfo[];
        item_container = document.getElementById("arrival_items");
        aas_search_item = document.getElementById("aas_search_item");
        aas_search_ean = document.getElementById("aas_search_ean");
        aas_search_placement = document.getElementById("aas_search_placement");
        aas_pending_status = document.getElementById("ass_pending_status");
        aas_pending_status_value = document.getElementById("ass_pending_status").querySelector("span");
        header_container = document.querySelector(".aas .placement_header") as HTMLElement;

        aas_current_count = document.getElementById("aas_current_count");
        aas_total_count = document.getElementById("aas_total_count");
        aas_sender = document.getElementById("aas_sender");
        aas_reference = document.getElementById("aas_reference");
        aas_finish_button = document.getElementById("aas_finish_button");
        aas_configure_po = document.getElementById("aas_configure_po");

        arrival_item_container = document.getElementById("arrival_item_container");
        lastScan: number;
        add_item_button = document.getElementById("add_arrival_item_button");
        arrival_quantity_plus_button = document.getElementById("arrival_quantity_plus_button");
        arrival_quantity_minus_button = document.getElementById("arrival_quantity_minus_button");
        arrivalId: string;
        placementId: number;
        edit: boolean;


        constructor() {
            super("app_arrival_show");
            App_Arrival_Show.instance = this;
            hub.on("arrivalItemAdded", (d) => this.arrivalItemAdded(d));
            hub.on("arrivalItemUpdated", (d) => this.arrivalItemUpdated(d));

            this.aas_search_item.addEventListener("click", async e => {
                await itemSearchAssistant.open(this.arrivalInfo.customerId, "", false, (info, extraData) => {
                    this.selectItem(info, null, extraData.purchaseOrderLineInfo, null);
                });
                this.add_purchase_order_to_search_result();
            });

            this.aas_search_ean.addEventListener("click", async e => {
                await itemSearchAssistant.open(this.arrivalInfo.customerId, "", true, (info, extraData) => {
                    this.selectItem(info, null, extraData.purchaseOrderLineInfo, null);
                });
                this.add_purchase_order_to_search_result();
            });

            this.aas_search_placement.addEventListener("click", e => {
                placementPickerAssistant.open(this.arrivalInfo.customerId, null, info => {
                    this.scanPlacement(info.id.toString());
                });
            });


            this.add_item_button.addEventListener("click", () => {
                this.postItems();
            });

            this.aas_finish_button.addEventListener("click", async () => {
                if (await SP.confirmX("Confirm")) {
                    var result = await SP.get<any>("/api/v1/arrival/finish/" + this.arrivalId);
                    if (result.status == 200) {
                        SP.Sounds.Success.play();
                        SP.setAllHash({ "app": "app_arrival" });
                        return;
                    }
                    else {
                        
                        await SP.alertX(result.msg);
                    }
                }
            });

            this.aas_configure_po.addEventListener("click", async () => {
                await SP.alertX("config");
            });

        }
        add_purchase_order_to_search_result() {
            this.arrivalInfo?.purchaseOrderInfo?.items?.forEach(i => {
                if (i.undeliveredQty <= 0) return;
                if (this.arrivalInfo?.arrivalLocation && this.arrivalInfo?.arrivalLocation != i.loc) return;

                var searchData = new ItemSearchExtraData();
                searchData.purchaseOrderLineInfo = i;

                let elm = itemSearchAssistant.addItem(i.itemInfo, searchData);
                let arrived = i.beeingDeliveredQty;
                let incomming = i.undeliveredQty;
                let finished = arrived == incomming;
                let labels = elm.querySelector(".labels");
                labels.innerHTML += ` <span class="label badge ${(finished ? "" : "label-warning")}">${SP.Localize("word_arrived")}<br /><span>${arrived} / ${incomming}</span></span>`;
            });
        }

        showAddButton() {
            if (Object.keys(this.scannedItems).length && this.placementId) this.add_item_button.style.display = "block";
            this.updateFinishButtonState();
        }

        async editStockingLot(lotId: string) {
            await this.reset();

            ignoreHashChange = true;
            SP.setHash("editLot", lotId);


            var data = await SP.Data.StockingLot.getStockingLotInfo(lotId, false);
            var itemData = await SP.Data.Item.getItemInfo(data.item.id, false);


            //set Item
            await this.selectItem(itemData, data, null, null);
            this.edit = true;
            //set stockpicker
            this.setPlacementInfo(data.stockPlacementId, data.stockPlacementData);

            this.add_item_button.innerHTML = SP.Localize("sentance_update_item");
            this.arrival_item_container.classList.add("edit-form");

            window.scrollTo(0, 0);
            ignoreHashChange = false;
            SP.Sounds.Click.play();

        }

        async setPlacementInfo(placementId: number, placementData: string) {
            this.placementId = placementId;
            if (!placementData) {
                var data = await SP.Data.Stock.getPlacementInfo(this.placementId, false);
                placementData = data.data;
            }
            var pi = new PlacementInfoBox(placementData, true, null);
            this.header_container.style.display = "block";
            this.header_container.innerHTML = "";
            this.header_container.appendChild(pi.container);
        }

        async reset(soft: boolean = false) {
            this.resetItems();
            this.placementId = null;
            this.lastScan = 0;
            this.arrival_item_container.classList.remove("edit-form");
            this.add_item_button.innerHTML = SP.Localize("sentance_add_item");
            this.header_container.style.display = "none";
            this.add_item_button.style.display = "none";
            this.header_container.innerHTML = "";

            if (this.edit) {
                ignoreHashChange = true;
                SP.setHash("editLot", null);
                this.edit = false;
                await SP.sleep(1);
                ignoreHashChange = false;
            }

            this.updateFinishButtonState();

        }

        resetItems() {

            for (var id in this.scannedItems) {
                this.scannedItems[id].container.remove();
            }
            this.scannedItems = {};
        }

        scannedItems: { [id: string]: ArrivalItem } = {};

        async selectItem(item: SP.ItemInfo, editLot: SP.StockingLotInfo = null, pol: SP.PurchaseOrderLineInfo, scannedBarode: string, gs1Data: SP.GS1Data = null) {
            if (this.edit) this.reset();




            //edit
            if (editLot) {
                await this.reset();
                pol ??= this.arrivalInfo?.purchaseOrderInfo?.items.find(l => l.id == editLot.purchaseOrderLineId);
                this.scannedItems[item.id] = new ArrivalItem(this.arrivalId, item, editLot, scannedBarode, pol, this.arrivalInfo.purchaseOrderInfo != null);
                this.setPlacementInfo(editLot.stockPlacementId, editLot.stockPlacementData);
                this.showAddButton();
                return;
            }




            //add/update
            let current = this.scannedItems[item.id];
            if (current == null || (pol != null && current.poInfo.id != pol.id)) {
                if (!App_Settings.userSettings.allow_mixed_arrival) this.resetItems();

                //get po items if any
                var items = this.arrivalInfo?.purchaseOrderInfo?.items;

                //filter items to current location arrivalLocation
                if (this.arrivalInfo?.arrivalLocation) items = items?.filter(i => i.loc == this.arrivalInfo.arrivalLocation);

                //get po with most undelivered
                pol ??= items?.filter(l => l.sku == item.sku && l.undeliveredQty - l.beeingDeliveredQty > 0)[0];

                //if no undelivered just pick last line
                pol ??= items?.slice().reverse().filter(l => l.sku == item.sku)[0];

                current = this.scannedItems[item.id] = new ArrivalItem(this.arrivalId, item, null, scannedBarode, pol, this.arrivalInfo.purchaseOrderInfo != null);
            }

            var qty = GetBarcodeQty(current.item.allBarcodes, scannedBarode);
            current.addQuantity(qty ? qty : 1);
            current.loadGS1Data(gs1Data);
            this.showAddButton();
        }

        async scanTote(toteId: string) {
            var toteInfo = await SP.Data.Tote.getToteInfo(toteId, true);
            await this.scanPlacement(toteInfo.totePlacementId.toString());
        }

        updateFinishButtonState() {
            var enabled = !this.arrivalInfo.arrivalFinished && Object.keys(this.scannedItems).length == 0;
            this.aas_finish_button.classList.toggle("disabled", !enabled);
        }

        async scanPlacement(placementId: string) {
            await SP.blurActive();
            var now = performance.now();

            var intPlacementId = parseInt(placementId);
            var post = ((intPlacementId == this.placementId && now - this.lastScan <= 1000) || App_Settings.userSettings.auto_double_scan_stocking);
            this.setPlacementInfo(intPlacementId, null);

            //double scan within 2 seconds
            if (post) {
                if (!Object.keys(this.scannedItems).length) return;
                return this.postItems();
            }

            this.lastScan = now;
            this.showAddButton();
        }

        async scanBarcode(barcode: string, gs1Data: SP.GS1Data) {
            await SP.blurActive();

            var current = null;
            for (var id in this.scannedItems) {
                if (this.scannedItems[id].barcodeScan == barcode) {
                    current = this.scannedItems[id];
                }
            }

            if (current) {
                var qty = GetBarcodeQty(current.item.allBarcodes, barcode);
                current.addQuantity(qty ?? 1);
                return;
            }

            //set current scan code
            StartLoading();
            await itemSearchAssistant.open(this.arrivalInfo.customerId, barcode, false, (info, extraData) => { this.selectItem(info, null, null, barcode, gs1Data); });
            if (itemSearchAssistant.resultCount == 0) {
                SP.Sounds.Error.play();
            }
            StopLoading();

        }

        posting = false;

        async postItems() {
            if (this.posting) return;
            this.posting = true;
            try {
                StartLoading();
                let finished = true;
                let items = 0;
                let total = 0;
                for (let id in this.scannedItems) {
                    let item = this.scannedItems[id];
                    items++;
                    total += item.quantity;
                    let success = await item.post(this.placementId);
                    if (!success) {
                        finished = false;
                    }
                }
                if (finished) {
                    if (total == 0) {
                        //??
                        //SP.Sounds.Error.play();
                    }

                    else if (App_Settings.userSettings.voice_arrival_confirm_quantity) {
                        let text = total.toString() + (items > 1 ? " " + SP.Localize("sentance_mixed_items") : "");
                        Talk(text, App_Settings.userSettings.voice_delay);
                    }
                    await this.reset();
                }
                StopLoading();
            }
            finally {
                this.posting = false;
            }
        }

        bound = false;

        async onOpen() {
            //clear
            this.item_container.innerHTML = "";
            this.arrivals = {};

            //get params
            this.arrivalId = SP.getHash("id");
            var editLot = SP.getHash("editLot");

            //get server data
            this.arrivalInfo = await SP.Data.Arrival.getArrivalInfo(this.arrivalId, false);
            this.aas_sender.innerHTML = this.arrivalInfo.arrivalSender;
            this.aas_reference.innerHTML = this.arrivalInfo.arrivalReferenceNo + (this.arrivalInfo.arrivalSenderReferenceNo ? " / " + this.arrivalInfo.arrivalSenderReferenceNo : "");

            this.items = await SP.Data.StockingLot.getArrivalStockingLotInfos(this.arrivalId, false);

            //bind events and groups
            if (!this.bound && !this.arrivalInfo.arrivalFinished) {
                this.bound = true;
                barcodeListener.on("sp", this.scanPlacement, this);
                barcodeListener.on("t", this.scanTote, this);
                barcodeListener.on(null, this.scanBarcode, this);
                await hub.connection.invoke("joinGroup", this.arrivalId);
            }

            //clear forms
            await this.reset();
            this.aas_pending_status.style.display = "none";

            //toggle form if edit
            document.getElementById("aas_arrival_form").style.display = this.arrivalInfo.arrivalFinished ? "none" : "block";

            //add pending lines
            this.aas_configure_po.style.display = "none";
            if (this.arrivalInfo.purchaseOrderInfo) {
                this.aas_configure_po.style.display = "block";
            }

            

            //render items
            this.items.forEach((i) => {
                var po_info = this.arrivalInfo?.purchaseOrderInfo?.items.find(x => x.id == i.purchaseOrderLineId);

                //Revert arrival counts for dislpay as open
                if (this.arrivalInfo.arrivalFinished && po_info) {
                    po_info.undeliveredQty += i.initialQuantity;
                    po_info.beeingDeliveredQty += i.initialQuantity;
                    po_info.deliveredQty -= i.initialQuantity;
                    po_info.itemTotalIncommingAllOrders += i.initialQuantity;
                }

                let item = this.arrivals[i.id] = new StockingLotElement(i, this.arrivalInfo, po_info);
                this.item_container.appendChild(item.html);
                this.updatePoInfos(po_info);

            });

            this.updateArrivalInfos();


            if (editLot?.length) {
                this.editStockingLot(editLot);
            }
        }

        public updatePoInfos(info: SP.PurchaseOrderLineInfo) {
            for (var id in this.arrivals) {
                var a = this.arrivals[id];
                if (a.POLine == info) a.updatePOInfo(this.arrivalInfo.arrivalFinished);
            }
        }

        public updateArrivalInfos() {
            var arrivalInfos = document.querySelectorAll(".arrival_items");
            for (var i = 0; i < arrivalInfos.length; i++) {
                arrivalInfos[i].innerHTML = "";
            }

            let totalLines = 0;
            let totalFinishedLines = 0;
            let totalItemsIncomming = 0;
            let totalArrivedItems = 0;

            for (var id in this.arrivals) {
                let a = this.arrivals[id];
                totalArrivedItems += a.data.initialQuantity;
            }

            if (this.arrivalInfo.purchaseOrderInfo) {
                this.arrivalInfo.purchaseOrderInfo.items.forEach(i => {

                    //skip if different location
                    if (this.arrivalInfo.arrivalLocation && this.arrivalInfo.arrivalLocation != i.loc) return;

                    let arrived = i.beeingDeliveredQty;
                    let incomming = i.undeliveredQty;
                    totalItemsIncomming += incomming;
                    if (incomming) totalLines++;
                    if (incomming && arrived == incomming) totalFinishedLines++;
                });
            }

            if (totalLines > 0) {
                this.aas_pending_status.style.display = "block";
                this.aas_pending_status_value.innerHTML = totalFinishedLines + " / " + totalLines;
                if (totalFinishedLines == totalLines) this.aas_pending_status.classList.remove("label-warning");
                else this.aas_pending_status.classList.add("label-warning");
            }

            this.aas_total_count.innerHTML = totalItemsIncomming ? totalItemsIncomming.toString() : "-";
            this.aas_current_count.innerHTML = totalArrivedItems ? totalArrivedItems.toString() : "-";
        }


        async onClose() {
            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("sp", this.scanPlacement);
                barcodeListener.off("t", this.scanTote);
                barcodeListener.off(null, this.scanBarcode);
                await hub.connection.invoke("leaveGroup", this.arrivalId);
            }
            itemSearchAssistant.close();
        }

        arrivalItemAdded(data: SP.StockingLotInfo) {
            var po_info = this.arrivalInfo?.purchaseOrderInfo?.items.find(x => x.id == data.purchaseOrderLineId);
            let item = this.arrivals[data.id] = new StockingLotElement(data, this.arrivalInfo, po_info);
            this.item_container.prepend(item.html);
            this.items.push(data);
            //var match = PurchaseOrderLineMatches[data.item.sku];
            //match.dirty = true;
            if (po_info) {
                po_info.beeingDeliveredQty += data.initialQuantity;
                this.updatePoInfos(po_info);
            }
            this.updateArrivalInfos();
        }

        arrivalItemUpdated(data: SP.StockingLotInfo) {
            var po_info = this.arrivalInfo?.purchaseOrderInfo?.items.find(x => x.id == data.purchaseOrderLineId);
            var current = this.arrivals[data.id];
            if (current != null) {
                var diff = data.initialQuantity - current.data.initialQuantity;
                current.data = data;
                current.updateText();
                //var match = PurchaseOrderLineMatches[data.item.sku];
                //match.dirty = true;
                if (current.POLine) {
                    current.POLine.beeingDeliveredQty += diff;
                    this.updatePoInfos(po_info);
                }
                this.updateArrivalInfos();

                if (data.initialQuantity == 0) {
                    current.html.remove();
                    delete this.arrivals[data.id];
                }
            }
        }
    }

    RegisterApp("app_arrival_show", App_Arrival_Show);
}